export default "__VITE_ASSET__FHI7KF43__"